export default __webpack_public_path__ + "static/57-6388d9e2a398b1c5fbca80be23e634ff.png";